/**
 * Base class name
 */
export var JUST_TEXT_BASE_CLASSNAME = 'ws10-just-text';
